import { Pipe, PipeTransform } from '@angular/core';
import { PageConfig } from '../entities';
import { UserRoles } from '../../user/entities/user-roles';
import { CurafidaFeatureEnum } from '../entities/base-page-config';
import { FeatureConfigs } from '../../common/entities/curafida-frontend-configuration';
import { ConfigurationResource, ConfigurationDetailFeatures } from '../resources/configuration.resource';

@Pipe({
    name: 'MenuItemsFilter',
})
export class MenuItemsFilterPipe implements PipeTransform {
    transform(
        menuItems: PageConfig[],
        userRoles: UserRoles[] | string[],
        globalConfiguration: FeatureConfigs,
        configurationFromBackend: ConfigurationResource,
    ) {
        // Do not show registration button if there is no registerUrl in config
        if (menuItems && !configurationFromBackend?.configuration?.features?.register?.enabled) {
            menuItems = menuItems.filter((x) => x.pageId !== 'REGISTER');
        }

        if (!userRoles) {
            return menuItems;
        }

        if (!menuItems) {
            return menuItems;
        }
        if (userRoles.length === 0) {
            return menuItems.filter((menuItem) => {
                const hasSubPage = menuItem.childPageConfigs?.length > 0;
                if (hasSubPage) {
                    return menuItem.role.length === 0;
                } else {
                    const featureKey = menuItem?.module as keyof FeatureConfigs;
                    if (
                        globalConfiguration[featureKey]?.enabled ||
                        globalConfiguration[featureKey]?.enabled === undefined ||
                        menuItem.module === CurafidaFeatureEnum.common
                    ) {
                        return menuItem.role.length === 0;
                    }
                }
            });
        }

        return menuItems.filter((menuItem) => {
            const hasSubPage = menuItem.childPageConfigs?.length > 0;
            if (hasSubPage) {
                return menuItem.role.find((role) => userRoles.includes(role as UserRoles));
            } else {
                if (menuItem.module === CurafidaFeatureEnum.common) {
                    return menuItem.role.find((role) => userRoles.includes(role as UserRoles));
                }
                const menuItemModule = menuItem?.module as keyof ConfigurationDetailFeatures;
                if (configurationFromBackend?.configuration?.features[menuItemModule]) {
                    if (configurationFromBackend?.configuration?.features[menuItemModule]?.enabled) {
                        return menuItem.role.find((role) => userRoles.includes(role as UserRoles));
                    } else {
                        return false;
                    }
                }
                if (globalConfiguration[menuItemModule as keyof FeatureConfigs]?.enabled) {
                    return menuItem.role.find((role) => userRoles.includes(role as UserRoles));
                } else {
                    return false;
                }
            }
        });
    }
}
